import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ngListService } from '../../list/core/ng-list.service';
import { SidePanelService } from '../../side-panel/core/side-panel.service';
import { ListAssignmentTabSideComponent } from '../../side-panel/states/list-assignment-tab-side/list-assignment-tab-side.component';
import { Section } from '../../store/model/section.model';
import { SectionService } from '../core/section.service';

@Component({
  selector: 'rl-sections-list',
  templateUrl: './sections-list.component.html',
  styleUrls: ['./sections-list.component.scss']
})
export class SectionsListComponent implements OnInit{

  @Input() sections : Section[] = [];
  @Input() collapsedAll : boolean; //(collapsedAll : boolean){
      //REMOVE WHEN MOVING TO ANGULAR
      //this.openAllSections
      //
  //}

  @Output() collapsedAllChange = new EventEmitter<boolean>();
  @Output() onDelete = new EventEmitter<Section>();

  //REMOVE WHEN MOVING TO ANGULAR
  @Input() set list(list : any){
    this.listService.currentList = list;
  };
  //

  scrollElement : HTMLElement = document.getElementById("PageContent") as HTMLElement;
  openAllSections : boolean;

  // sortConfig : SortableOptions = {
  //   onUpdate : (e : any) => {
  //     //since sortablejs already updated the 'sections' list in that point, we need to send the new index twice
  //     this.updateOrder(e.newIndex, e.newIndex);
  //   }
  // }
  
  constructor(private sidePanel : SidePanelService, private listService : ngListService, private sectionService : SectionService) { }

  ngOnInit(): void {
    //!!!REMOVE WHEN LIST TABS MOVE TO FULL ANGULAR!!!//
    this.sidePanel.setDefaultState(ListAssignmentTabSideComponent);
    this.openAllSections = !this.collapsedAll;
    //
  }

  removeSectionFromList(i : number){
    this.onDelete.emit(this.sections[i]);
    this.sections.splice(i, 1);
  }
  
  updateOrder(oldOrder : number, newOrder : number){
    //    handleFiltered(section, evt.models, evt.oldIndex, evt.newIndex);
    this.sectionService.order(this.sections[oldOrder].id, newOrder).subscribe(s => {
      //this.sections[sId] = s;
      let s1 = this.sections[oldOrder];
      let s2 = this.sections[newOrder];
      s2.order = s1.order;
      s1.order = newOrder;

      this.sections[oldOrder] = s2;
      this.sections[newOrder] = s1;
    });
  }
  
  updateIndentation(i : number, newIndentation : number){
    this.sections[i].indentation = newIndentation;
    this.sectionService.save(this.sections[i]).subscribe(s => this.sections[i] = s);
  }

  updateCollapsedAll(sectionOpened : boolean){
    if(sectionOpened && this.collapsedAll){
      this.collapsedAllChange.emit(false);
    }
  }

  // Full angular - collapsed all function, and remove this.openAllSections
}
